import { Injectable } from '@angular/core';
import { cacheable, Cache } from '../../cache/index';
import { BenchmarkOccupation } from '../../core-data-model/BenchmarkOccupation.model';
import { BenchmarkOccupationServer } from '../../core-data-model/BenchmarkOccupationApi.serverinterface';
import { ApiService } from '../../system-services/Api.service';
import { BenchmarkOccupationTransformers } from './BenchmarkOccupationApi.datatransform';

@Injectable({
    providedIn: 'root'
})
export class BenchmarkOccupationApi {
    private benchmarkOccupationMatchCache = new Cache<
        BenchmarkOccupation[],
        string
    >('benchmarkOccupationMatchCache', (jobTitle: string) => jobTitle);

    constructor(
        private api: ApiService,
        private transformer: BenchmarkOccupationTransformers
    ) {}

    @cacheable(
        function (this: BenchmarkOccupationApi) {
            return this.benchmarkOccupationMatchCache;
        },
        (jobTitle: string) => jobTitle,
        null,
        null
    )
    getPossibleOccupations(
        jobTitle: string,
        resultsCount = 10
    ): Promise<BenchmarkOccupation[]> {
        // Currently the API returns top 10, but we want at most 5.
        return this.api
            .get<BenchmarkOccupationServer>(
                `/api/v3/jobs/matchJobs?jobTitle=${jobTitle}`
            )
            .then(([response]) =>
                response
                    .slice(0, resultsCount)
                    .map((entry) =>
                        this.transformer.transformFromServer(entry, jobTitle)
                    )
            );
    }
}
